import React from 'react';
import  Christmas2023  from 'views/Christmas2023';

const SchoolProgrampage = () => {
  return <Christmas2023 />;
};

export default SchoolProgrampage;